import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ArrayManipulations } from 'app/BaseFramework/core/utilities/arrayManipulations';
import { forIn } from 'types/lodash';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}


@Component({
  selector: 'app-proposal-questionnaire',
  templateUrl: './proposal-questionnaire.component.html',
  styleUrls: ['./proposal-questionnaire.component.scss']
})
export class ProposalQuestionnaireComponent implements OnInit {
  _currentComponentName = "QuestionnaireComponent"
  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    public commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    public lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private arrayManipulations: ArrayManipulations) { }

  @Input() IO
  insuredClientList
  insuredlistSubject$;
  //Declaraions which might need developer input
  lookupsToBind = []
  selectorOfThisComponent = 'app-questionnaire'
  parentEvent$
  environment = environment
  languageCd = this.appMetadataHandler.defaultLanguage

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() transactionState: string;

  private _IO
  public _questionnaire = []
  private _receivedQuestionnaire = []
  @Input()
  set inputDataForEdit(value: any) {

  };


  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  UItoServerTransform(payload, response) {
    let questionnaire = response.componentData
    if (payload && response) {
      payload['questionnaires'] = this.commonUtilty.deepCopy(questionnaire)
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        // let validationResult = this.validateOutput(this.claimsInsuredCoverageDecisionForm)
        let validationResult = { isInvalid: false } // remove if any customized validations to be added.
        if (!validationResult.isInvalid) {
          this.EmitComponentOutput([])
        }
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }

  ngOnInit() {
    if (this.IO) {
      let primaryInsured = this.commonUtilty.extractClientDOListFromIOGeneric(this.IO, 'PRIMARYINSURED')
      let insureds = this.commonUtilty.extractClientDOListFromIOGeneric(this.IO, 'INSURED')
      this.insuredClientList = [...primaryInsured, ...insureds]
    } else {
      let insuredList = [];
      if (this.insuredlistSubject$ != null)
        this.insuredlistSubject$.unsubscribe();

      this.insuredlistSubject$ = this.interactService.addClientSubject$.subscribe(res => {
        console.log("client list in product coverages component", JSON.stringify(res));

        if (res) {
          if (res.role != 'Policy Holder') insuredList.push(res.clientDO);
        }
      })
      this.insuredClientList = insuredList;
      console.log("insured list in questionnaire component", JSON.stringify(this.insuredClientList));
    }
    this.subscribeToParentEvent()
  }

}
